module.exports = __webpack_public_path__ + "img/logo2.b7c2e0ea.png";